import angular from 'angular';
import { PostWorkOrderPayoutModalComponent } from './post-work-order-payout-modal.component';

export const PayoutPostingModule = angular
    .module("apex.mainApp.payout.posting", [])
    .component("apexPostWorkOrderPayoutModal", PostWorkOrderPayoutModalComponent)
    .name;
